/** Bandeiras configuráveis no cadastro de formas de pagamento (cartão). */
export const PAYMENT_CARD_BRAND_OPTIONS = [
  { slug: "visa", label: "Visa" },
  { slug: "mastercard", label: "Mastercard" },
  { slug: "elo", label: "Elo" },
  { slug: "amex", label: "American Express" },
  { slug: "hipercard", label: "Hipercard" },
  { slug: "diners", label: "Diners Club" },
  { slug: "discover", label: "Discover" },
];

/** Tipos que representam cartão de crédito (manter alinhado à API). */
export const CARD_PAYMENT_TIPOS = new Set([2, 4, 9, 10, 13, 14]);

export function isCardPaymentTipo(tipo) {
  const n = Number(tipo);
  return Number.isFinite(n) && CARD_PAYMENT_TIPOS.has(n);
}

const VALID_SLUGS = new Set(PAYMENT_CARD_BRAND_OPTIONS.map((o) => o.slug));

export function parseBandeirasAceitasFromPaymentMethod(pm) {
  const raw = pm?.bandeiras_aceitas;
  if (raw == null || raw === "") return [];
  if (Array.isArray(raw)) {
    return raw.map((s) => String(s || "").trim().toLowerCase()).filter((s) => VALID_SLUGS.has(s));
  }
  if (typeof raw === "string") {
    try {
      const j = JSON.parse(raw);
      if (Array.isArray(j)) {
        return j.map((s) => String(s || "").trim().toLowerCase()).filter((s) => VALID_SLUGS.has(s));
      }
    } catch {
      return raw
        .split(/[,;|]+/)
        .map((s) => s.trim().toLowerCase())
        .filter((s) => VALID_SLUGS.has(s));
    }
  }
  return [];
}
